import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { SharedFeaturesService } from 'src/app/services/shared-features.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe, TitleCasePipe } from '@angular/common';
import { SolutionsAppService } from 'src/app/services/solutions-app.service';
import { map } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ShowDialogsComponent } from 'src/app/components/show-dialogs/show-dialogs.component';

@Component({
  selector: 'app-configure-pipeline',
  template: `
    <div class="cp-wrap">
      <!-- Add a pipeline -->
      <div class="sec-lbl">Add a pipeline</div>
      <div class="addbar">
        <mat-form-field appearance="fill" class="fld-type">
          <mat-label>Select Pipeline</mat-label>
          <mat-select [(ngModel)]="selectedValue" name="food">
            <mat-option
              *ngFor="let value of pipelines"
              [value]="getKeys(value)"
            >
              {{ value[getKeys(value)] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="fld-name">
          <mat-label>Customize Pipeline Name</mat-label>
          <input type="text" matInput [(ngModel)]="pipeline_name_display" />
        </mat-form-field>

        <button
          type="button"
          class="btn-primary"
          [disabled]="!selectedValue"
          (click)="generatePipeline()"
        >
          <svg
            viewBox="0 0 24 24"
            width="16"
            height="16"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M12 5v14M5 12h14" />
          </svg>
          Add pipeline
        </button>
      </div>

      <!-- Pipelines list -->
      <div class="sec-lbl">Pipelines</div>

      <div class="rows" *ngIf="configuredPipeline">
        <div
          class="empty"
          *ngIf="configuredPipeline.length === 0"
        >
          No pipelines yet. Add one above to get started.
        </div>

        <div
          class="row"
          *ngFor="let pipeN of configuredPipeline; let i = index"
        >
          <mat-checkbox
            class="cp-check"
            (change)="addCheckedPipelines($event, pipeN.pipeline_id)"
          ></mat-checkbox>

          <span
            class="nm"
            [routerLink]="pipeN?.pipeline_id + '/configureNodes'"
          >
            {{
              pipeN.pipeline_name_display &&
              pipeN.pipeline_name_display !== 'pipeline_name_display'
                ? (pipeN.pipeline_name_display | textpretty | titlecase)
                : (pipeN.pipeline_name | textpretty | titlecase)
            }}
          </span>

          <span class="when">{{ pipeN.created_dtm | date : 'medium' }}</span>

          <button
            type="button"
            class="iconbtn"
            title="Edit"
            [routerLink]="pipeN?.pipeline_id + '/configureNodes'"
          >
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 20h9" />
              <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4Z" />
            </svg>
          </button>

          <button
            type="button"
            class="iconbtn"
            title="Run"
            (click)="runPipelineById(pipeN.pipeline_id, pipeN.pipeline_name)"
          >
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="currentColor"
              stroke="none"
            >
              <path d="M8 5v14l11-7z" />
            </svg>
          </button>

          <button type="button" class="iconbtn" title="Preview">
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12Z" />
              <circle cx="12" cy="12" r="3" />
            </svg>
          </button>

          <button
            type="button"
            class="iconbtn danger"
            title="Delete"
            (click)="deletePipeline(pipeN.pipeline_id)"
          >
            <svg
              viewBox="0 0 24 24"
              width="15"
              height="15"
              fill="none"
              stroke="currentColor"
              stroke-width="1.8"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 6h18" />
              <path d="M8 6V4h8v2" />
              <path d="M6 6l1 14h10l1-14" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./configure-pipeline.component.scss'],
})
export class ConfigurePipelineComponent implements OnInit {
  pipelines: any[] = [{ data_processing: 'DataProcessing' }];
  selectedValue: any | string = false;
  pipeline_name_display: string = '';
  configuredPipeline: any;
  checkedPipelineList: string[] = [];
  activeProject: any;
  solutionId: any = '';
  versionId: any = '';

  constructor(
    private solutionServices: SolutionsAppService,
    private snackBar: SharedFeaturesService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private datePipe: DatePipe,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    let url = '';
    this.route.parent?.params
      .pipe(map((params: any) => params))
      .subscribe((parentParams) => {
        url = parentParams.projectId;
        this.solutionId = parentParams.solutionId;
        this.versionId = parentParams.versionId;
      });
    this.solutionServices.getAvailableProjects({"solution_id":this.solutionId},{"version_id":this.versionId},url).subscribe({
      next: (response: any) => {
        this.activeProject = response;
        this.getConfiguredPipeline();
      },
      error: (error: any) => {
        console.error('an error occurred', error);
      },
    });
    this.solutionServices.getavailablePipelines().subscribe(
      (result: any) => {
        this.pipelines = result;
      },
      (error: any) => {
        console.error('an error occurred', error);
      }
    );
  }

  addCheckedPipelines(event: any, id: string) {
    this.checkedPipelineList = this.checkedPipelineList.filter(
      (element) => element !== id
    );
    if (event.checked) {
      this.checkedPipelineList.push(id);
    }
    this.solutionServices.setMyVariable(this.checkedPipelineList);
  }
  getKeys(data: {}): string {
    return Object.keys(data)[0];
  }

  generatePipeline() {
    let pipelineObject = {
      pipeline_name: this.selectedValue,
      pipeline_name_display: this.pipeline_name_display || this.selectedValue,
    };
    this.solutionServices
      .createPipeline(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.activeProject.project_id,
        pipelineObject
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            'pipeline created successfully',
            'Close',
            'success-snackbar'
          );
          this.router.navigate([response.pipeline_id + '/configureNodes'], {
            relativeTo: this.route,
          });
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            this.snackBar.convertErrorToString(error?.error),
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  getConfiguredPipeline() {
    this.solutionServices
      .getConfiguredPipelines(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.activeProject?.project_id
      )
      .subscribe(
        (result: any) => {
          this.configuredPipeline = result;
        },
        (error) => {
          this.configuredPipeline = [];
        }
      );
  }

  deletePipeline(pipeId: string) {
    const ref = this.dialog.open(ShowDialogsComponent, {
      data: {
        title: 'Delete this pipeline?',
        message:
          'This permanently removes the pipeline and all of its steps. This action cannot be undone.',
        confirmText: 'Delete',
        cancelText: 'Cancel',
        danger: true,
      },
      disableClose: false,
    });
    ref.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        this.doDeletePipeline(pipeId);
      }
    });
  }

  private doDeletePipeline(pipeId: string) {
    this.solutionServices
      .deletePipeline(
        { solution_id: this.solutionId },
        { version_id: this.versionId },
        this.activeProject.project_id,
        pipeId
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            'pipeline deleted successfully',
            'Close',
            'success-snackbar'
          );
          this.getConfiguredPipeline();
          this.changeDetectorRef.detectChanges();
        },
        error: (error: any) => {
          this.snackBar.openSnackBar(
            this.snackBar.convertErrorToString(error?.errors),
            'Close',
            'error-snackbar'
          );
        },
      });
  }

  runPipelineById(pipelineId: string, pipelineName: string) {
    let tempPipeName = new TitleCasePipe();
    pipelineName = tempPipeName.transform(pipelineName.replace('_', ' '));
    this.snackBar.openSnackBar(
      `${pipelineName} is running...`,
      'Close',
      'progress-snackbar'
    );
    let temp = {
      project_ids: [],
      pipeline_ids: [pipelineId],
      node_ids: [],
      tags: [],
    };
    this.solutionServices
      .runVersionOrProjectOrPipelineOrNode(
        this.solutionId,
        this.versionId,
        temp
      )
      .subscribe({
        next: (response: any) => {
          this.snackBar.openSnackBar(
            `Pipeline run queued${response?.task_id ? ` (task #${String(response.task_id).slice(0, 8)})` : ''} — we'll let you know when it finishes.`,
            'Close',
            'success-snackbar'
          );
        },
        error: (error) => {
          this.snackBar.openSnackBar(
            error.error.error,
            'Close',
            'error-snackbar'
          );
        },
      });
  }
}
